module.exports = __webpack_public_path__ + "static/media/slide16.06fe60df.png";